import GCLogo from "assets/img/growthcloud/growthcloud_wordmark.svg";
import GCSymbol from "assets/img/growthcloud/growthcloud_symbol.svg";

const LoadingView = () => {
  return (
    <div
      style={{ width: "100vw", height: "100vh" }}
      className="d-flex justify-content-center align-items-center"
    >
      <div className="d-flex">
        <img
          alt=""
          src={GCLogo}
          style={{ width: 180, marginRight: 50, marginLeft: 10 }}
          className="d-none d-md-block ml-0"
        />
        <img
          alt=""
          src={GCSymbol}
          style={{ height: 24, marginRight: 50, marginLeft: 10 }}
          className="d-block d-md-none ml-0"
        />
      </div>
    </div>
  );
};

export default LoadingView;
